/**
 * @file index.tsx
 *
 * @fileoverview This component is used to store the UTM source parameter from the url in the session storage,
 * so can be used later.
 */
import { getServerConfigByName } from '~/jobiqo/lib/config';
import { useEffect } from 'react';
import { AppConfig } from '~/jobiqo/models/config';

interface SourceTrackingProps {
  /**
   * Information passed by Next.js router.
   */
  router: any;
  /**
   * Backend configuration.
   */
  backendConfig: AppConfig[];
}
export const SourceTracking = ({
  backendConfig,
  router,
}: SourceTrackingProps) => {
  const CREATION_SOURCE_ENABLED: boolean = !!getServerConfigByName(
    backendConfig,
    'jobiqo_creation_source',
  )?.value[0];

  // Using useEffect to make sure session storage is available.
  useEffect(() => {
    // If we have an utm_source in the query string we store it in session storage.
    if (
      CREATION_SOURCE_ENABLED &&
      router?.query?.utm_source &&
      !sessionStorage.getItem('utm-source')
    ) {
      sessionStorage.setItem('utm-source', router.query.utm_source);
    }
  }, []);

  return null;
};

export default SourceTracking;
